<script>
	import { onMount } from "svelte";
	import model from "../../stores/modelStore";
	import lookups from "../../stores/lookupStore";
	import businesses from "../../stores/businessesStore";
	import {
		projectSettings,
		acceptedFileUploadList,
		yesNoUnsureOptions,
		neverSometimesAlwaysOptions
	} from "../../config";
	import { isValid } from "../../validation";
	import { unformatDate } from "../../helpers/dateHelpers";
	import { registerPageComplete } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import DatePicker from "../../components/DatePicker.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import AutoCompleteSelector from "../../components/AutoCompleteSelector.svelte";
	import StoreList from "../../components/StoreList.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import CheckboxButtonList from "../../components/CheckboxButtonList.svelte";

	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let buttons = null;
	let validated = false,
		dateFinishValid = true,
		dateFinishError = false;

	const storeLookupUrl = `/api/store-lookup?q=`;

	const id = "fileUploader";
	const options = {
		url: "/api/file-upload?token=" + $model.registrationToken,
		acceptedFiles: acceptedFileUploadList,
		fileUploadToken: $model.registrationToken
	};

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	$model.documentList = $model.documentList || [];
	$model.currentBusiness = null;

	// const classificationOtherId = $lookups.classification.filter((l) => l.lookupName === "Other")[0].id;

	onMount(() => {
		window.scrollTo(0, 0);
	});

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = [...isValid()];

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<PageSection>
	<Form {disabled} id="form-action-specific" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName} Shift Class Actions</h4>

				<h1 class="text-center">Additional Details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<YesNoGroup
					{required}
					{disabled}
					name="WillingToSpeakTeam"
					label="Are you willing to speak with our team about your experience on a confidential basis?"
					bind:value={$model.WillingToSpeakTeam} />
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<YesNoGroup
					{required}
					{disabled}
					name="WillingToSpeakMedia"
					label="Are you willing to speak about your experience publicly including with the media?"
					bind:value={$model.WillingToSpeakMedia} />
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Next" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	label span.isrequired {
		color: var(--color-error);
		left: 4px;
		position: relative;
		font-size: 1.2em;
	}
</style>
